import { createFileRoute } from '@tanstack/react-router';
import { creatorPortalBriefQuery } from '@/services/creator-portal';
import { CreatorPortalBrief } from '@/features/creator-portal/brief-page';

/**
 * A deal's brief on the creator's portal, to read. The loader starts the read (a deal id that isn't a number reads
 * nothing: the page says it can't find it) and never waits for it.
 */
export const Route = createFileRoute('/creator/$token/briefs/$dealId')({
  loader: ({ context: { queryClient }, params }) => {
    if (/^\d+$/.test(params.dealId)) void queryClient.prefetchQuery(creatorPortalBriefQuery(params.token, Number(params.dealId)));
  },
  component: CreatorPortalBriefRoute,
});

function CreatorPortalBriefRoute() {
  const { token, dealId } = Route.useParams();
  return <CreatorPortalBrief token={token} dealId={dealId} />;
}
